import React from 'react'
import useProps from './useProps'
import Layout from './Layout'

export const Login = () => <Layout {...useProps()} />
